import { inject } from 'inversify';

import { STATUS } from '@/constants';
import { UserController } from '@/controllers/UserController';
import { service } from '@/decorators/service';
import { SignalrListener, SignalrMessage } from '@/decorators/signalr';
import { Logger } from '@/services/Logger';
import { Signalr } from '@/services/signalr/Signalr';
import { LateReasonsStore } from '@/stores/LateReasonsStore';
import { mapValueProperty } from '@/utils/mapValueProperty';
import { orderByField } from '@/utils/orderBy';
import type { ILateReasonInfo } from '~/api/ILateReasonInfo';
import type { ILateReasonRespMsg } from '~/api/messages/ILateReasonRespMsg';

@SignalrListener
@service(LateReasonsManager)
export class LateReasonsManager {
  @inject(Logger) protected logger: Logger;
  @inject(Signalr) protected signalr: Signalr;
  @inject(UserController) protected userController: UserController;
  @inject(LateReasonsStore) protected lateReasonsStore: LateReasonsStore;

  find(id: string) {
    return this.lateReasonsStore.find(id);
  }

  get all() {
    const lateReasons = this.lateReasonsStore.all()
      .filter((lateReason) => lateReason.status !== STATUS.DISABLED);
    return orderByField(lateReasons, this.lateReasonsStore.valueKey);
  }

  reset() {
    this.lateReasonsStore.set([]);
  }

  updateLateReasons(lateReasons: ILateReasonInfo[]) {
    // Used mapValueProperty as status is coming in as null
    this.lateReasonsStore.batchUpdate(mapValueProperty(lateReasons));
  }

  @SignalrMessage('LateReasonRespMsg')
  protected onLateReasonRespMsg(response: ILateReasonRespMsg) {
    this.updateLateReasons(response.lateReasons);
  }
}
